// extracted by mini-css-extract-plugin
export var menuItem = "B_tf d_fW d_bw d_bz d_bL d_bb";
export var menuItemSub = "B_tg d_W d_bw d_bL";
export var menuMainLink = "B_th d_fX d_dx";
export var menuLink = "B_tj d_fX d_dx";
export var Link = "B_r0 s_r0 s_rk s_rF";